import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useMemo, type ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../auth/AuthProvider";
import { normalizeAppEnvironment } from "../config/env";
import { ErrorBoundary } from "../errors/ErrorBoundary";
import { BrowserObservabilityClient } from "../observability/clients";
import { createStartupRuntimeContext } from "./runtimeContext";

export function AppProviders({ children }: { children: ReactNode }) {
  const queryClient = useMemo(() => new QueryClient(), []);
  const observability = useMemo(
    () =>
      new BrowserObservabilityClient(
        createStartupRuntimeContext(
          normalizeAppEnvironment(import.meta.env.VITE_APP_ENV),
        ),
      ),
    [],
  );

  return (
    <ErrorBoundary observability={observability}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>{children}</AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
